/**
 * @description 库存分析-tabs库存明细模块
 */
<template>
    <div>
        <gj-table
            ref="gjTable"
            size='has-picture'
            name="flag"
            :height="400"
            :index="false"
            :data="tableData"
            :columns="columns"
            :loading="loading"
            border="default"
            :adapt-height="false"
            :default-sort="{prop: 'inStockQuantity', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
            <template v-slot:productName="{ row }">
                <div>
                    <gj-tooltip :text-line="1" :content="row.productName">{{
                    row.productName | defaultShow
                    }}</gj-tooltip>
                </div>
                <div>
                    <gj-tooltip :text-line="1" :content="row.sku">{{
                    row.sku | defaultShow
                    }}</gj-tooltip>
                </div>
                <div v-show="!row.productName && !row.sku">-</div>
            </template>
        </gj-table>
    </div>
</template>

<script>
import {isMeaningfulMixin, queryMixin, selectionMixin} from "@/minxins";
import { ProductEnum } from "@/utils/options";
import { storageAnalysisStorageList } from "@/api/statistics";
import { INVENTORY_DETAILS_COLUMN } from "../config.js"
export default {
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin],
    inject: ["getPageParams"],
    computed: {
        pageParams () {
            return this.getPageParams()
        },
    },
    filters: {
        ProductEnum(val, type) {
            return ProductEnum[type].reduce((str, item) => {
                item.id == val && (str = item.text)
                return str
            }, "")
        }
    },
    data() {
        return {
            loading: false,
            columns: INVENTORY_DETAILS_COLUMN,
            tableData: [],
        }
    },
    created() {
        this.sort.prop = "inStockQuantity"
    },
    methods: {
        $gjQueryInitParams() {},
        $gjQuery() {
           this.storageAnalysisStorageList()
        },
        // 获取库存明细table数据
        async storageAnalysisStorageList() {
            this.loading = true
            let params = {
                asinCode: this.pageParams.asinCode,
                asinType: this.pageParams.asinType,
                countryIds: this.pageParams.countryData.countryIds,
                marketIds: this.pageParams.countryData.marketIds,
                ...this.querySort
            }
            try {
                let res = await storageAnalysisStorageList(params)
                this.tableData = res || []
            } finally {
                this.loading = false
            }
        }
    }
};
</script>

<style scoped lang="scss">
.row-asin {
    cursor: pointer;
    color: #0046f0;
}
</style>
